module.exports = __webpack_public_path__ + "static/media/ellab-ireland.a5a16be4.png";